import BookingsService from '@/shared/types/bookings/service.type';
import Response from '@/shared/types/response';
import fetcher from '@/shared/utils/fetcher';
import getCookie from '@/shared/utils/getCookie';

const createBookingService = async <B = unknown>(
  body: B,
  onUnauthorized?: () => void,
) => {
  const token = getCookie('auth_token');

  try {
    const response = await fetcher<Response<BookingsService>>({
      url: '/bookings/services/create/',
      method: 'POST',
      body,
      token,
      onUnauthorized,
    });

    return response;
  } catch (error) {
    console.error(
      'Error occurred in function "createBookingService" in file "src/shared/api/bookings/services/createBookingService.ts":',
      error,
    );
    return error as Response<BookingsService>;
  }
};

export default createBookingService;
